import { graphql } from "../../generated";

export const productByEANQuery = graphql(/* GraphQL */ `
    query ProductByEAN($ean: String!, $excludeProductId: String, $locale: String) {
        productByEAN(ean: $ean, excludeProductId: $excludeProductId, locale: $locale) {
            id
            locales
            fallbackLocale
            locale
            isLocalized
            name
            slug
            category {
                key
            }
            codes {
                ean
            }
            info {
                manufacturer {
                    id
                    name
                    logo {
                        src
                    }
                }
                model
            }
            thumbnailImage {
                id
                src
            }
        }
    }
`);
